import React from 'react';

import { type CardSize } from '../../../../types';

import { NoResults } from './no-results';
import { RestrictedContent } from './restricted-content';

export type CommonCardErrorStateProps = {
	cardHeight: number;
	cardId: string;
	cardSize: CardSize;
	errorStatus: string;
	isCardSelected?: boolean;
	isInViewMode: boolean;
};

export type CardErrorStateProps = {
	isNoResult: boolean;
	isRestricted: boolean;
	link?: string;
} & CommonCardErrorStateProps;

export const CardErrorState = ({
	link,
	isRestricted,
	isNoResult,
	...erroredStatePassThroughProps
}: CardErrorStateProps) => {
	if (isRestricted) {
		return <RestrictedContent link={link} {...erroredStatePassThroughProps} />;
	}

	if (isNoResult) {
		return <NoResults {...erroredStatePassThroughProps} />;
	}

	return null;
};
